<template>
  <div>
    <a-card class="filter-card">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" allow-clear @change="onSearch">
                <a-select-option :value="0"> 使用中 </a-select-option>
                <a-select-option :value="1"> 已启用 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="onSearch">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card size="small">
      <a-tabs>
        <a-tab-pane key="0" tab="流程模板列表" />
        <a-button slot="tabBarExtraContent" type="primary" icon="plus" @click="onAdd"> 新增 </a-button>
      </a-tabs>
      <workflow-list ref="workflowListRef" />
    </a-card>
  </div>
</template>

<script>
import { debounce } from 'lodash';

import WorkflowList from '@/pages/system/workflow/components/WorkflowList';

export default {
  components: { WorkflowList },
  data() {
    return {
      filterForm: {
        status: null
      }
    };
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    handleChange: debounce(function () {
      this.onSearch();
    }, 500),

    onSearch() {
      this.$nextTick(() => {
        this.$refs.workflowListRef.onFilter({ ...this.filterForm });
      });
    },

    onReset() {
      this.filterForm.status = null;
      this.onSearch();
    },

    onAdd() {
      this.$router.push({
        name: 'pages:system:workflow:edit'
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-tabs-tab {
  margin-right: 4px;
}

.filter-card {
  margin-bottom: 16px;
}

.search-form .ant-form-item {
  display: flex;
}

/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}
</style>
